import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["name", "margin", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes } from '../customPropTypes/spacing';
import IllustrationNames from './IllustrationNames';
import { jsx as _jsx } from "react/jsx-runtime";
function Illustration(_ref) {
  var name = _ref.name,
    margin = _ref.margin,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_illustration'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_jsx("img", _extends({}, otherProps, {
    alt: name,
    className: cssClasses.join(' '),
    src: "https://screentone.dowjones.io/assets/".concat(name, ".svg?src=st_illustration"),
    crossOrigin: "anonymous"
  }));
}
process.env.NODE_ENV !== "production" ? Illustration.propTypes = {
  /** Name of the illustration to be displayed */
  name: PropTypes.oneOf(IllustrationNames).isRequired,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes
} : void 0;
Illustration.defaultProps = {
  className: null,
  margin: null
};
export default Illustration;